import { createElement, isNullOrUndefined as isNOU, detach, addClass, Browser, removeClass } from '@syncfusion/ej2-base';
import * as CONSTANT from './../base/constant';
import * as classes from './../base/classes';
import { InsertHtml } from './inserthtml';
import * as EVENTS from './../../common/constant';
import { scrollToCursor } from '../../common/util';
/**
 * Audio internal component
 *
 * @hidden
 * @private
 */
var AudioCommand = /** @class */ (function () {
    /**
     * Constructor for creating the Audio plugin
     *
     * @param {IEditorModel} parent - specifies the parent element
     * @hidden
     * @private
     */
    function AudioCommand(parent) {
        this.parent = parent;
        this.addEventListener();
    }
    AudioCommand.prototype.addEventListener = function () {
        this.parent.observer.on(CONSTANT.AUDIO, this.audioCommand, this);
        this.parent.observer.on(EVENTS.INTERNAL_DESTROY, this.destroy, this);
    };
    AudioCommand.prototype.removeEventListener = function () {
        this.parent.observer.off(CONSTANT.AUDIO, this.audioCommand);
        this.parent.observer.off(EVENTS.INTERNAL_DESTROY, this.destroy);
    };
    /**
     * audioCommand method
     *
     * @param {IHtmlItem} e - specifies the element
     * @returns {void}
     * @hidden
     * @private
     */
    AudioCommand.prototype.audioCommand = function (e) {
        var selectNode;
        var audiowrapper;
        var value = e.value.toString().toLowerCase();
        if (value === 'inline' || value === 'break' || value === 'audioremove') {
            selectNode = e.item.selectNode[0];
            audiowrapper = selectNode.closest('.' + classes.CLASS_AUDIO_WRAP);
        }
        switch (value) {
            case 'audio':
            case 'audioreplace':
                this.createAudio(e);
                break;
            case 'inline':
                selectNode.removeAttribute('class');
                audiowrapper.style.display = 'inline-block';
                addClass([selectNode], [classes.CLASS_AUDIO, classes.CLASS_AUDIO_INLINE, classes.CLASS_AUDIO_FOCUS]);
                this.callBack(e);
                break;
            case 'break':
                selectNode.removeAttribute('class');
                audiowrapper.style.display = 'block';
                addClass([selectNode], [classes.CLASS_AUDIO_BREAK, classes.CLASS_AUDIO, classes.CLASS_AUDIO_FOCUS]);
                this.callBack(e);
                break;
            case 'audioremove':
                if (audiowrapper) {
                    detach(audiowrapper);
                }
                else {
                    detach(selectNode);
                }
                this.callBack(e);
                break;
        }
    };
    AudioCommand.prototype.createAudio = function (e) {
        var _this = this;
        var isReplaced = false;
        var wrapElement;
        if (!isNOU(e.item.selectParent) && e.item.selectParent[0].classList &&
            (e.item.selectParent[0].classList.contains(classes.CLASS_CLICK_ELEM) ||
                e.item.selectParent[0].classList.contains(classes.CLASS_AUDIO_WRAP) || e.item.selectParent[0].tagName === 'AUDIO')) {
            var audioEle = e.item.selectParent[0].querySelector('source');
            this.setStyle(audioEle, e, audioEle);
            isReplaced = true;
        }
        else {
            wrapElement = createElement('span', { className: classes.CLASS_AUDIO_WRAP, attrs: { contentEditable: 'false', title: ((!isNOU(e.item.title)) ? e.item.title : (!isNOU(e.item.fileName) ? e.item.fileName : '')) } });
            var audElement = createElement('audio', { className: classes.CLASS_AUDIO + ' ' + classes.CLASS_AUDIO_INLINE, attrs: { controls: '' } });
            var sourceElement = createElement('source');
            var clickElement = createElement('span', { className: classes.CLASS_CLICK_ELEM });
            this.setStyle(sourceElement, e, audElement);
            audElement.appendChild(sourceElement);
            clickElement.appendChild(audElement);
            wrapElement.appendChild(clickElement);
            if (!isNOU(e.item.cssClass)) {
                if (e.item.cssClass === classes.CLASS_AUDIO_BREAK) {
                    wrapElement.style.display = 'block';
                }
            }
            if (!isNOU(e.item.selection)) {
                e.item.selection.restore();
            }
            var isPasteCleanup = !isNOU(e.selector) && e.selector === 'pasteCleanupModule';
            if (isPasteCleanup) {
                if (!isNOU(this.parent.currentDocument)) {
                    e.callBack({
                        requestType: 'Audios',
                        editorMode: 'HTML',
                        event: e.event,
                        range: this.parent.nodeSelection.getRange(this.parent.currentDocument),
                        elements: [audElement]
                    });
                }
                return;
            }
            InsertHtml.Insert(this.parent.currentDocument, wrapElement, this.parent.editableElement);
            if (!isNOU(e.item.selection)) {
                var range = e.item.selection.getRange(this.parent.currentDocument);
                var focusNode = document.createTextNode('\u00A0');
                var node = this.parent.nodeSelection.getSelectedNodes(this.parent.currentDocument)[0];
                wrapElement.parentNode.insertBefore(focusNode, node.nextSibling);
                e.item.selection.save(range, this.parent.currentDocument);
            }
            else if (isNOU(e.item.selection) && !e.callBack) {
                this.setMediaElementCursor(wrapElement, this.parent.currentDocument);
            }
        }
        if (e.callBack && (isNOU(e.selector) || !isNOU(e.selector) && e.selector !== 'pasteCleanupModule')) {
            var selectedNode = this.parent.nodeSelection.getSelectedNodes(this.parent.currentDocument)[0];
            var audioElm_1 = (e.value === 'AudioReplace' || isReplaced) ? ((e.item.selectParent[0].tagName.toLowerCase() === 'audio') ? e.item.selectParent[0] : e.item.selectParent[0].querySelector('audio'))
                : (Browser.isIE ? selectedNode : selectedNode.querySelector('audio'));
            var onAudioLoadEvent_1 = function () {
                if (e.value !== 'AudioReplace' || !isReplaced) {
                    if (!isNOU(_this.parent.currentDocument)) {
                        if (_this.parent.userAgentData.isSafari()) {
                            scrollToCursor(_this.parent.currentDocument, _this.parent.editableElement);
                        }
                        if (!(!isNOU(e.event) && !isNOU(e.event.name) && (e.event.name) === 'drop')) {
                            e.callBack({
                                requestType: 'Audios',
                                editorMode: 'HTML',
                                event: e.event,
                                range: _this.parent.nodeSelection.getRange(_this.parent.currentDocument),
                                elements: [audioElm_1]
                            });
                        }
                    }
                }
                audioElm_1.removeEventListener('loadeddata', onAudioLoadEvent_1);
            };
            audioElm_1.addEventListener('loadeddata', onAudioLoadEvent_1);
            if (isReplaced) {
                audioElm_1.load();
            }
        }
    };
    // Sets cursor position after inserting media elements (audio/video).
    AudioCommand.prototype.setMediaElementCursor = function (mediaElement, docElement) {
        var parentElement = mediaElement.parentElement;
        var mediaIndex = Array.prototype.indexOf.call(parentElement.childNodes, mediaElement);
        if (mediaIndex !== -1) {
            this.parent.nodeSelection.setSelectionText(docElement, parentElement, parentElement, mediaIndex + 1, mediaIndex + 1);
        }
    };
    AudioCommand.prototype.setStyle = function (sourceElement, e, audioEle) {
        if (!isNOU(e.item.url)) {
            sourceElement.setAttribute('src', e.item.url);
        }
        var fileExtension = e.item.fileName ? e.item.fileName.split('.').pop().toLowerCase() :
            e.item.url ? e.item.url.split('.').pop().toLowerCase() : '';
        if (fileExtension === 'opus') {
            sourceElement.type = 'audio/ogg';
        }
        else if (fileExtension === 'm4a') {
            sourceElement.type = 'audio/mp4';
        }
        else {
            sourceElement.type = e.item.fileName && e.item.fileName.split('.').length > 0 ?
                'audio/' + e.item.fileName.split('.')[e.item.fileName.split('.').length - 1] :
                e.item.url && e.item.url.split('.').length > 0 ? 'audio/' + e.item.url.split('.')[e.item.url.split('.').length - 1] : '';
        }
        if (!isNOU(e.item.cssClass) && audioEle.nodeName === 'AUDIO') {
            if (e.item.cssClass === classes.CLASS_AUDIO_BREAK) {
                addClass([audioEle], [classes.CLASS_AUDIO_BREAK]);
                removeClass([audioEle], [classes.CLASS_AUDIO_INLINE]);
            }
            else {
                addClass([audioEle], [classes.CLASS_AUDIO_INLINE]);
                removeClass([audioEle], [classes.CLASS_AUDIO_BREAK]);
            }
        }
    };
    AudioCommand.prototype.callBack = function (e) {
        if (e.callBack) {
            e.callBack({
                requestType: e.item.subCommand,
                editorMode: 'HTML',
                event: e.event,
                range: this.parent.nodeSelection.getRange(this.parent.currentDocument),
                elements: this.parent.nodeSelection.getSelectedNodes(this.parent.currentDocument)
            });
        }
    };
    AudioCommand.prototype.destroy = function () {
        this.removeEventListener();
    };
    return AudioCommand;
}());
export { AudioCommand };
